const colToRows = (colsCount, column) => {
	const { length } = column;

	colsCount = Math.min(colsCount, length) || 1;
	const fullColsCount = length % colsCount || colsCount;
	const fullRowsCount = Math.floor(length / colsCount);
	const rowsCount = Math.ceil(length / colsCount);

	const shortColumnOffset = rowsCount * fullColsCount;

	return Array.from(
		{ length: rowsCount }, //
		(_, row) =>
			Array.from(
				{ length: row < fullRowsCount ? colsCount : fullColsCount }, //
				(__, col) =>
					col < fullColsCount
						? column[col * rowsCount + row]
						: column[
								shortColumnOffset + (col - fullColsCount) * fullRowsCount + row
							],
			),
	);
};

export default colToRows;
